import React, { useEffect, useState } from "react";
import { PartyPopper, Flag, Ribbon, Share2 } from "lucide-react";
import api from "@/lib/api";
import { ShareCardModal } from "@/components/ShareCardModal";

const TYPE_STYLE = {
  holiday: { icon: Flag, label: "Holiday", badge: "bg-ink text-gold" },
  celebration: { icon: PartyPopper, label: "Celebration", badge: "bg-gold text-ink" },
  recognition: { icon: Ribbon, label: "Day of Recognition", badge: "bg-paper text-ink border border-ink" },
};

export const ObservanceSection = ({ ddmm }) => {
  const [obs, setObs] = useState(null);
  const [shareOpen, setShareOpen] = useState(false);

  useEffect(() => {
    if (!ddmm) return;
    setObs(null);
    api.get(`/observances/${ddmm}`).then((r) => setObs(r.data)).catch(() => setObs(false));
  }, [ddmm]);

  if (!obs) return null;
  const style = TYPE_STYLE[obs.type] || TYPE_STYLE.celebration;
  const Icon = style.icon;

  return (
    <section id="observance" data-testid="observance-section" className="mt-10">
      <div className="relative overflow-hidden rounded-2xl border border-ink bg-paper px-6 py-7 md:px-10 md:py-9">
        <div className="absolute -right-10 -top-10 w-44 h-44 rounded-full border-[14px] border-gold/15 pointer-events-none" />
        <div className="relative flex flex-col md:flex-row md:items-center gap-5 md:gap-8">
          <div className="shrink-0 w-14 h-14 rounded-full bg-ink text-gold flex items-center justify-center">
            <Icon className="w-7 h-7" />
          </div>
          <div className="flex-1 min-w-0">
            <div className="flex flex-wrap items-center gap-2">
              <span data-testid="observance-type" className={`inline-flex items-center px-3 py-1 rounded-full text-[10px] font-bold uppercase tracking-[0.18em] ${style.badge}`}>
                {obs.type_label || style.label}
              </span>
              <span className="text-[12px] text-ink-muted">{obs.date_label}</span>
            </div>
            <h2 data-testid="observance-name" className="mt-2 text-2xl md:text-3xl font-bold text-ink leading-tight">{obs.name}</h2>
            <p data-testid="observance-details" className="mt-2 text-[15px] text-ink-muted leading-relaxed max-w-2xl">{obs.details}</p>
          </div>
          <button type="button" data-testid="observance-share-btn" onClick={() => setShareOpen(true)} className="self-start md:self-center shrink-0 inline-flex items-center gap-2 px-5 h-11 rounded-full bg-ink text-white text-sm font-semibold hover:bg-gold hover:text-ink transition-colors">
            <Share2 className="w-4 h-4" /> Share this day
          </button>
        </div>
      </div>
      <ShareCardModal
        open={shareOpen}
        onClose={() => setShareOpen(false)}
        analyticsName="observance_card"
        testPrefix="observance-card"
        shareUrl={`${window.location.origin}/?date=${obs.date_dd_mm}`}
        card={{ badge: obs.type_label, greeting: obs.type === "recognition" ? "Today is" : "Happy", title: obs.name, body: obs.details, dateLabel: obs.date_label }}
      />
    </section>
  );
};
